import React from 'react';

/**
 * Section heading in reference style:
 * — EYEBROW LABEL —
 * Big serif with one word italicized in Dancing Script pink
 *
 * Usage:
 *   <SectionHeading eyebrow="Our Plans" title="Choose Your" accent="Perfect" tail="Plan" />
 *   → "— Our Plans —"
 *     "Choose Your Perfect Plan" with "Perfect" in pink Dancing Script italic
 */
const SectionHeading = ({ eyebrow, title = '', accent, tail = '', subtitle, align = 'center', className = '' }) => {
  const alignCls = align === 'left' ? 'text-left' : 'text-center';
  return (
    <div className={`${alignCls} ${className}`}>
      {eyebrow && (
        <div className={`flex items-center gap-3 ${align === 'left' ? 'justify-start' : 'justify-center'} mb-4`}>
          <span className="h-px w-8 bg-pink-brand/60" />
          <span className="text-[11px] sm:text-xs font-semibold uppercase tracking-[0.28em] text-pink-brand">
            {eyebrow}
          </span>
          <span className="h-px w-8 bg-pink-brand/60" />
        </div>
      )}
      <h2 className="font-display font-semibold text-3xl sm:text-4xl md:text-5xl text-stone-900 leading-tight">
        {title}
        {accent && (
          <>
            {' '}
            <em className="font-script not-italic text-pink-brand font-semibold">{accent}</em>
          </>
        )}
        {tail && <> {tail}</>}
      </h2>
      {subtitle && (
        <p className={`mt-4 text-base md:text-lg text-stone-600 max-w-2xl ${align === 'left' ? '' : 'mx-auto'}`}>
          {subtitle}
        </p>
      )}
    </div>
  );
};

export default SectionHeading;
